import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  startRatingImage,
  photoUserImage,
  whiteArrowImage,
  calendarImage,
  requestsImage,
  chatImage,
  paymentImage,
  aboutImage,
  logoutImage,
  companyProfilePicImage,
  mapIconImage,
  emailIconImaage,
  phoneIconImage,
  editBillingIconImage,
  editIconImage,
  truckImg1Image,
  truckImg2Image,
  addIconImage,
} from "../../assets";
import { Header } from "./components";
import { Link, withRouter } from "react-router-dom";
import { invokeApi, s3baseUrl } from "../../bl_libs/invokeApi";
import { useSockets } from "../../Context/Context-Sockets/ContextSockets";
import { Badge } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import { useSnakbar } from "../../Context/Context-Snakbar/ContextSnackbar";

const Main = (props) => {
  const { socketOFF, userList, handleRefreshChatList } = useSockets();
  const { showErrorSnak, showSuccessSnak } = useSnakbar();
  const [foreman, setForeman] = useState(
    JSON.parse(localStorage.getItem("user"))
  );
  const { children } = props;
  const [sideNavActive, setSideNavActive] = useState(false);
  const [active, setActive] = useState(0);

  const [userProfile, setUserProfile] = useState("");

  const handleBadgeDot = () => {
    let message = userList.find((user) => user.unread_messages > 0);

    return message ? false : true;
  };

  let chatDot = handleBadgeDot();

  const logout = () => {
    let requestObj = {
      path: "/app_api/log_out",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    invokeApi(requestObj).then((res) => {
      localStorage.clear();
      props.history.push("/login");
      socketOFF();
    });
  };

  const handleClickOnSidebar = (value) => {
    if (window.innerWidth < 769) {
    }
    setSideNavActive(false);
    setActive(value);
  };

  const GetForemanProfile = (type) => {
    let requestObj = {
      path: "/api/foreman/profile_foreman",
      method: "GET",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        localStorage.setItem("user", JSON.stringify(res.profile));
      } else {
        //showErrorSnak(res.message);
      }
    });
  };

  useEffect(() => {
    GetForemanProfile();
  }, []);

  useEffect(() => {
    const currentPath = props.history.location.pathname;
    console.log(currentPath);
    if (currentPath.search("/calender") > 0) {
      setActive(1);
    } else if (currentPath.search("/foreman-requests") > 0) {
      setActive(2);
    } else if (currentPath.search("/chats") > 0) {
      setActive(3);
    } else if (currentPath.search("/payment-history") > 0) {
      setActive(4);
    } else if (currentPath.search("/about-us") > 0) {
      setActive(5);
    } else {
      setActive("");
    }
  }, [props.history.location.pathname]);

  useEffect(() => {}, []);

  return (
    <>
      <Header
        sideNavActive={sideNavActive}
        setSideNavActive={setSideNavActive}
        setActive={setActive}
        userProfile={userProfile}
      />

      <div className="wrapper">
        {/* <!-- Sidebar  --> */}
        <nav
          id="sidebar"
          className={
            sideNavActive
              ? "handle-custom-sidebar"
              : "handle-custom-sidebar active"
          }
          style={
            window.innerWidth < 769
              ? {
                  position: "fixed",
                  zIndex: 1000,
                  height: "100vh",
                  overflowY: "auto",
                  overflowX: "hidden",
                  paddingTop: 0,
                  marginTop: 0,
                }
              : {}
          }
        >
          <div className="sidebar-top-custom">
            {/* <div className="sidebar-profile float-left">
              <div className="profile_picture">
                <img
                  style={{ width: 90, height: 90, borderRadius: "50%" }}
                  src={
                    foreman.profile_pic === ""
                      ? photoUserImage
                      : s3baseUrl + foreman.profile_pic
                  }
                />
              </div>
              <h6 className="text-white">
                {foreman.first_name + " " + foreman.last_name}
              </h6>
               <div className="caption text-white rating-text">
                <span>Rating 4.5</span> <img src={startRatingImage} />
              </div> 
            </div> */}
            <div className="toggle-menu float-right">
              <button
                type="button"
                id="sidebarCollapse"
                className="btn"
                onClick={() => setSideNavActive(!sideNavActive)}
              >
                <img src={whiteArrowImage} />
              </button>
            </div>
            <div className="clearfix"></div>
            {/* <div className="search-button-wrapper">
              <button className="custom-btn-small red-btn">Search</button>
            </div> */}
          </div>

          <ul className="list-unstyled components">
            <li className={active === 1 ? "active" : ""}>
              <Link
                to="/foreman/calender"
                onClick={() => handleClickOnSidebar(1)}
              >
                <img src={calendarImage} /> <span>Calendar</span>
              </Link>
            </li>
            <li className={active === 2 ? "active" : ""}>
              <Link
                to="/foreman/foreman-requests"
                onClick={() => handleClickOnSidebar(2)}
              >
                <img src={requestsImage} /> <span>Foreman Requests</span>
              </Link>
            </li>
            <li className={active === 3 ? "active" : ""}>
              <Link
                to="/foreman/chats"
                onClick={() => {
                  handleRefreshChatList();
                  handleClickOnSidebar(3);
                }}
              >
                <Badge
                  style={{ paddingLeft: 0 }}
                  color="primary"
                  variant="dot"
                  invisible={chatDot}
                >
                  <img src={chatImage} />
                </Badge>{" "}
                <span>Chat</span>
              </Link>
            </li>

            <li className={active === 5 ? "active" : ""}>
              <Link
                to="/foreman/about-us"
                onClick={() => handleClickOnSidebar(5)}
              >
                <InfoIcon style={{ color: "black" }} /> <span>About Us</span>
              </Link>
            </li>
            {/* <li>
              <Link
                data-toggle="modal"
                data-target="#logout"
                onClick={() => handleClickOnSidebar(active)}
              >
                <img src={logoutImage} /> <span>Log Out</span>
              </Link>
            </li> */}
          </ul>
        </nav>
        {/* <!-- Page Content  --> */}
        {children}
      </div>

      <div
        className="modal fade"
        id="logout"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="logout-title"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content pb-30">
            <div className="modal-header text-center border-0 pb-0">
              <button
                type="button"
                className="close black-color"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="form-wrapper pl-4 pr-4 pl-sm-5 pr-sm-5">
              <div className="modal-body p-0">
                <h5 className="text-center" id="logout-title">
                  Log out
                </h5>
                <p className="text-center sub-title pb-4 mb-3 pt-40">
                  Are your sure you want to logout?
                </p>
                <div className="row justify-content-center text-center">
                  <div className="col-6">
                    <button
                      onClick={logout}
                      data-dismiss="modal"
                      aria-label="Close"
                      className="custom-btn-small custom-buton float-right"
                    >
                      Yes
                    </button>
                  </div>
                  <div className="col-6">
                    <button
                      data-dismiss="modal"
                      aria-label="Close"
                      className="custom-btn-small custom-buton custom-button-pink float-left"
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

Main.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default withRouter(Main);
